import { useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();

  const globalState = useSelector((state) => state.userReducer);

  // console.log(globalState, "global state");

  useEffect(() => {
    if (!globalState?.isUserLoggedIn) {
      navigate("/login");
    }
  }, [globalState?.isUserLoggedIn, navigate]);

  return globalState?.isUserLoggedIn ? children : null;
};

export default PrivateRoute;
